import { useEffect } from 'react'

interface NavigatorHints { deviceMemory?: number; connection?: { saveData?: boolean } }

/**
 * Low-end phones struggle with lots of live blur. On devices with little memory or few CPU cores, or when
 * the visitor has Data Saver on, add a `lite` class that lightens the glass and stops ambient animation.
 */
export function usePerformanceMode() {
  useEffect(() => {
    const n = navigator as Navigator & NavigatorHints
    const lowCores = typeof n.hardwareConcurrency === 'number' && n.hardwareConcurrency <= 4
    const lowMemory = typeof n.deviceMemory === 'number' && n.deviceMemory <= 4
    const saveData = !!n.connection?.saveData
    const coarse = window.matchMedia?.('(pointer: coarse)').matches
    if (saveData || lowMemory || (coarse && lowCores)) document.documentElement.classList.add('lite')
  }, [])
}
